import React from 'react'

const ExternalLink = ({ url, children, style }) => {
  return (
    <a href={url} style={style} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  )
}

export default ExternalLink



// WEBPACK FOOTER //
// ./src/components/shared/ExternalLink.js